import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { ReturnsStore } from '../../core/store/returns.state';

@Component({
  selector: 'app-service-down-notification-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './service-down-notification-modal.component.html',
  styleUrls: ['../error-notification-modal/error-notification-modal.component.scss']
})
export class ServiceDownNotificationModalComponent {
  private _store = inject(ReturnsStore);
  private _modalRef = inject(MatDialogRef<ServiceDownNotificationModalComponent>);

  customerSupportEmail: string = this._store.getCurrentState().customerSupportEmail;

  close(): void {
    this._modalRef.close();
  }
}
